import React, { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from './pages/Home';
import Nav from './components/Nav';
import Login from './pages/Login';
import firebase from './db/firebase';
import RequestList from './pages/RequestList';
import RequestsQuotation from './pages/RequestsQuotation';
import RemoteSurveys from './pages/RemoteSurveys';
import SurveyDetail from './pages/SurveyDetail';
import Users from './pages/Users';
import RequestsMoney from './pages/RequestsMoney';
import RequestsProducts from './pages/RequestsProducts';
import RequestMoneyDetail from './pages/RequestMoneyDetail';
import Products from './pages/Products';
import PurchasePoints from './pages/PurchasePoints';
import AppSettings from './pages/AppSettings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';
import SendNotifications from './pages/SendNotifications';
import BugReport from './pages/BugReport';

const Router = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // para esperar a que cargue el estado de auth

  useEffect(() => {
    const unsubscribe = firebase.auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className='w-full h-screen flex items-center justify-center text-white'>Cargando...</div>;
  }

  return (
    <BrowserRouter>
      <div className='w-full h-screen flex bg-white'>
        {user && <Nav />}
        <Routes>
          {user ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/requests" element={<RequestList />} />
              <Route path="/requests-quotation" element={<RequestsQuotation />} />
              <Route path="/remote-surveys" element={<RemoteSurveys />} />
              <Route path="/requests-money" element={<RequestsMoney />} />
              <Route path="/requests-money/:id" element={<RequestMoneyDetail/>} />
              <Route path="/requests-products" element={<RequestsProducts />} />
              <Route path="/purchase-points" element={<PurchasePoints />} />
              <Route path="/users" element={<Users />} />
              <Route path="/send-notifications" element={<SendNotifications />} />
              <Route path="/bug-report" element={<BugReport />} />
              <Route path="/products" element={<Products />}/>
              <Route path="/app-settings" element={<AppSettings />}/>
              <Route path="/remote-surveys/:id" element={<SurveyDetail/>} />
              <Route path="/login" element={<Navigate to="/" />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
              {/* <Route path="/" element={<SurveyDetail/>} /> */}

            </>
          ) : (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
              <Route path="/delete-account" element={<DeleteAccount/>} />
              

            </>
          )}
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default Router;